import {
  AccountTree,
  Contacts,
  Dashboard,
  Facebook,
  FlightTakeoff,
  History,
  HubOutlined,
  QuestionAnswer,
  SettingsOutlined,
} from "@mui/icons-material";
import { Box, Typography, styled } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import { routesConstants } from "../../utils/constants";
import { useSelector } from "react-redux";
import { RootState } from "../../services/redux/store";

const SiderBar = () => {
  const { userProfile_data } = useSelector(
    (store: RootState) => store.authStore
  );
  const { pathname } = useLocation();
  return (
    <MainContainer>
      {/* logo secction */}
      <Link to={"/"}>
        <div className="logo_container">
          <img alt="logo" src="/assets/logo.png" className="logo_img" />
        </div>
      </Link>
      {/* navigation's icon's */}
      <div className="navigations_container">
        {/* Dashboard */}
        <Box>
          <Link to={routesConstants.home} style={{ color: "#0a474c" }}>
            <IconContainer>
              <Box
                className="icon_wrap"
                sx={
                  pathname === routesConstants.home
                    ? { background: "#fff", color: "#0a474c !important" }
                    : { color: "#fff" }
                }
              >
                <Dashboard className="icon" />
              </Box>
              <Typography className="text">Dashboard</Typography>
            </IconContainer>
          </Link>
        </Box>
        {/* live chat */}
        <Link to={routesConstants.liveChat} style={{ color: "#0a474c" }}>
          <IconContainer>
            <Box
              className="icon_wrap"
              sx={
                pathname === routesConstants.liveChat
                  ? { background: "#fff", color: "#0a474c !important" }
                  : { color: "#fff" }
              }
            >
              <QuestionAnswer className="icon" />
            </Box>
            <Typography className="text">Live Chat</Typography>
          </IconContainer>
        </Link>
        {/* History */}
        <Link to={routesConstants.history} style={{ color: "#0a474c" }}>
          <IconContainer>
            <Box
              className="icon_wrap"
              sx={
                pathname === routesConstants.history
                  ? { background: "#fff", color: "#0a474c !important" }
                  : { color: "#fff" }
              }
            >
              <History className="icon" />
            </Box>
            <Typography className="text">History</Typography>
          </IconContainer>
        </Link>
        {/* Contacts */}
        <Link to={routesConstants.contacts} style={{ color: "#0a474c" }}>
          <IconContainer>
            <Box
              className="icon_wrap"
              sx={
                pathname === routesConstants.contacts
                  ? { background: "#fff", color: "#0a474c !important" }
                  : { color: "#fff" }
              }
            >
              <Contacts className="icon" />
            </Box>
            <Typography className="text">Contacts</Typography>
          </IconContainer>
        </Link>
        {/* Compaigns */}
        <Link to={routesConstants.compaigns} style={{ color: "#0a474c" }}>
          <IconContainer>
            <Box
              className="icon_wrap"
              sx={
                pathname === routesConstants.compaigns
                  ? { background: "#fff", color: "#0a474c !important" }
                  : { color: "#fff" }
              }
            >
              <FlightTakeoff className="icon" />
            </Box>
            <Typography className="text">Compaigns</Typography>
          </IconContainer>
        </Link>
        {/* Ads Manager */}
        <Link to={routesConstants.adsManager} style={{ color: "#0a474c" }}>
          <IconContainer>
            <Box
              className="icon_wrap"
              sx={
                pathname === routesConstants.adsManager
                  ? { background: "#fff", color: "#0a474c !important" }
                  : { color: "#fff" }
              }
            >
              <Facebook className="icon" />
            </Box>
            <Typography className="text">Ads Manager</Typography>
          </IconContainer>
        </Link>
        {/* Flows */}
        <Link to={routesConstants.flow} style={{ color: "#0a474c" }}>
          <IconContainer>
            <Box
              className="icon_wrap"
              sx={
                pathname === routesConstants.flow
                  ? { background: "#fff", color: "#0a474c !important" }
                  : { color: "#fff" }
              }
            >
              <HubOutlined className="icon" />
            </Box>
            <Typography className="text">Flows</Typography>
          </IconContainer>
        </Link>
        {/* Manager */}
        <Link
          to={`${routesConstants.manage}${routesConstants.templateMessage}`}
          style={{ color: "#0a474c" }}
        >
          <IconContainer>
            <Box
              className="icon_wrap"
              sx={
                pathname.includes(routesConstants.manage)
                  ? { background: "#fff", color: "#0a474c !important" }
                  : { color: "#fff" }
              }
            >
              <SettingsOutlined className="icon" />
            </Box>
            <Typography className="text">Manage</Typography>
          </IconContainer>
        </Link>
      </div>
      <div className="bottom_content">
        {/* all project */}
        <Link
          to={routesConstants.projects}
          style={{ color: "#0a474c" }}
          replace
        >
          <IconContainer>
            <Box
              className="icon_wrap"
              sx={
                pathname === routesConstants.projects
                  ? { background: "#fff", color: "#0a474c !important" }
                  : { color: "#fff" }
              }
            >
              <AccountTree className="icon" />
            </Box>
            <Typography className="text">All Project</Typography>
          </IconContainer>
        </Link>
        <Box
          className="profile_section"
          component={Link}
          to={`${routesConstants.profile}${routesConstants.yourProfile}`}
        >
          <div className="profile_circle">
            <Typography>
              {String(userProfile_data.firstName).slice(0, 1)}
            </Typography>
          </div>
        </Box>
      </div>
      {/* footer section */}
    </MainContainer>
  );
};

export default SiderBar;
const MainContainer = styled("div")`
  height: 100%;
  .logo_container {
    width: 70px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    position: fixed;
    top: 0;
    padding-top: 10px;
    background-color: var(--primary);
    img {
      height: 28px;
      width: 100%;
      object-fit: contain;
    }
  }
  .navigations_container {
    margin: 55px auto;
  }
  .bottom_content {
    position: fixed;
    bottom: 0;
  }
  .profile_section {
    width: 70px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: 10px;
    background-color: var(--primary);
    text-decoration: none;
    .profile_circle {
      height: 40px;
      width: 40px;
      border-radius: 50%;
      background-color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      p {
        font-size: 25px;
        color: var(--primary);
      }
    }
  }
`;
const IconContainer = styled("div")`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 15px;
  text-decoration: none;

  .icon_wrap {
    height: 35px;
    width: 35px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .icon {
    font-size: 23px;
  }
  .text {
    color: #fff;
    font-size: 10px;
    margin-top: 2px;
  }
`;
